import { render, staticRenderFns } from "./ProspectParrainage.vue?vue&type=template&id=64c6325c"
import script from "./ProspectParrainage.vue?vue&type=script&lang=ts"
export * from "./ProspectParrainage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports